/*
 * @Author: chenguanghua
 * @Date: 2022-07-26
 * @LastEditors: chengunghua
 * @LastEditTime: 2022-07-26
 * @Description: 代办报告项目
 */

const dbbgRoutes = {
  path: 'dbbg',
  name: 'dbbg',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'dbbgManage',
      component: () => import(/* webpackChunkName: "dbbgManageList" */ '@/features/xfwbgl/dbbg/list.vue'),
      meta: {
        navtabTitle: '代办报告项目',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default dbbgRoutes;
